'use client';

import { c as _c } from "react/compiler-runtime";
import { MotionConfig, motion } from 'framer-motion';
import type React from 'react';
import { SiteFooter } from './site-footer';
import { SiteHeader } from './site-header';
type PageShellProps = {
  kicker?: string;
  title: string;
  subtitle: string;
  children: React.ReactNode;
};
export function PageShell(t0) {
  const $ = _c(26);
  const {
    kicker,
    title,
    subtitle,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SiteHeader />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden="true" className="absolute inset-0 bg-dot-grid opacity-25" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== kicker) {
    t3 = kicker && <motion.span initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: "easeOut"
    }} className="inline-flex w-fit items-center gap-2 rounded-full border border-borderPrimary bg-backgroundPrimary/60 px-4 py-1.5 font-mono text-contentTertiary text-xs uppercase tracking-widest backdrop-blur"><span className="size-1.5 rounded-full bg-algoprimary" />{kicker}</motion.span>;
    $[2] = kicker;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      y: 20
    };
    t5 = {
      opacity: 1,
      y: 0
    };
    t6 = {
      duration: 0.6,
      delay: 0.1,
      ease: "easeOut"
    };
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== title) {
    t7 = <motion.h1 initial={t4} animate={t5} transition={t6} className="font-bold text-6xl text-contentPrimary tracking-tight sm:text-7xl">{title}</motion.h1>;
    $[7] = title;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t10;
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      opacity: 0,
      y: 16
    };
    t9 = {
      opacity: 1,
      y: 0
    };
    t10 = {
      duration: 0.6,
      delay: 0.2,
      ease: "easeOut"
    };
    $[9] = t10;
    $[10] = t8;
    $[11] = t9;
  } else {
    t10 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== subtitle) {
    t11 = <motion.p initial={t8} animate={t9} transition={t10} className="max-w-3xl text-2xl text-contentSecondary leading-relaxed">{subtitle}</motion.p>;
    $[12] = subtitle;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t3 || $[16] !== t7) {
    t12 = <section className="relative overflow-hidden">{t2}<div className="relative mx-auto flex w-full max-w-6xl flex-col gap-6 px-6 py-24 sm:py-32">{t3}{t7}{t11}</div></section>;
    $[14] = t11;
    $[15] = t3;
    $[16] = t7;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== children) {
    t13 = <section className="mx-auto w-full max-w-6xl px-6 pb-32">{children}</section>;
    $[18] = children;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12 || $[21] !== t13) {
    t14 = <main className="flex flex-1 flex-col">{t12}{t13}</main>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SiteFooter />;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t14) {
    t16 = <MotionConfig reducedMotion="user"><div className="flex min-h-screen flex-col">{t1}{t14}{t15}</div></MotionConfig>;
    $[24] = t14;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  return t16;
}